import ProtectedLayout from './ProtectedLayout';

export default ProtectedLayout;
